/**
 * 查询个播主播列表
 */

import React from 'react';
import styled from 'styled-components';
import { useNumber, useStateful } from 'react-hanger';

import { hooks, request } from '@/lib';
import { ListEmpty, UiScroll } from '@/components';

import ListItem from './list-item';
import { Button } from '@/client/widgets/ui';

const StageStarList = () => {
  const keyword = useStateful('');
  const reloadId = useNumber(0);

  const { source: list = [] } = hooks.useSimpleFetch(
    () =>
      request.funny
        .get('api/v1/multiRoom/war/liveRooms', {
          keyword: keyword.value,
        })
        .then((source) => {
          return source.data.slice(0, 20);
        }),
    [reloadId.value],
  );

  const reloadList = hooks.useDebounceFn(() => {
    reloadId.increase();
  }, 300);

  const handleInputChange = (e) => {
    keyword.setValue(e.target.value);
    reloadList.run();
  };

  const handleClear = () => {
    reloadList.run();
    keyword.setValue('');
  };

  const handleSearch = () => {
    //
  };

  return (
    <Wrap>
      <div className="search">
        <div className="search-input">
          <span className="iconfont icon-sousuo1"></span>
          <input
            type="text"
            placeholder="请输入主播昵称或ID"
            value={keyword.value}
            onChange={handleInputChange}
            maxLength={16}
          />
          {keyword.value.length > 0 && (
            <span
              title="清空"
              className="clear iconfont icon-guanbi2fill"
              onClick={handleClear}
            ></span>
          )}
          <Button type="primary" onClick={handleSearch}>
            搜索
          </Button>
        </div>
      </div>
      <UiScroll overflowY className="search-list">
        {!list.length || !keyword.value ? (
          <ListEmpty>
            {keyword.value
              ? '没有搜索到你想要的内容哦～'
              : '搜索你想要PK的主播昵称或ID哦~'}
          </ListEmpty>
        ) : (
          <ul>
            {list.map((item) => {
              return <ListItem key={item.uid} item={item} />;
            })}
          </ul>
        )}
      </UiScroll>
    </Wrap>
  );
};

const Wrap = styled.div`
  ._dark & {
    .search-input {
      background-color: rgba(129, 133, 155, 0.3);
    }
  }

  .search {
    margin: 0 16px;
    padding: 12px 0;
    font-size: var(--fs-base);

    &-input {
      background-color: rgba(129, 133, 155, 0.1);
      height: 34px;
      display: flex;
      border-radius: 100px;
      align-items: center;
    }

    .iconfont {
      margin: 0 8px 0 16px;
      color: #d7d7d7;
    }

    .clear {
      color: #7b8186;
      cursor: pointer;
    }

    button {
      width: 90px;
      border-radius: 0 90px 90px 0;
      height: 34px;
    }

    input {
      flex: auto;
    }
    input::-webkit-input-placeholder {
      color: rgba(255, 255, 255, 0.3) !important;
    }
  }
  .search-list {
    padding: 0 16px;
    height: 408px;
  }
  .list-empty {
    .img {
      height: 200px;
      margin-top: -30px;
      background: url(${require('../images/img-empty.png')}) no-repeat center /
        contain;
    }
  }
`;

export default StageStarList;
